import { makeAutoObservable, runInAction } from "mobx";
import { RootStore, ServiceStore } from "@intrasync/stores";

class LoadStagingWizardStore {
  rootStore: RootStore;

  activeStep = 0;
  loading = false;
  error: string | null = null;
  success: string | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });
  }

  setActiveStep = (step: number) => {
    this.activeStep = step;
  };

  nextStep = () => {
    this.activeStep++;
  };

  prevStep = () => {
    this.activeStep--;
  };

  setError = (error: string | null) => {
    this.error = error;
  };

  setSuccess = (success: string | null) => {
    this.success = success;
  };

  reset = () => {
    this.activeStep = 0;
    this.loading = false;
    this.error = null;
    this.success = null;
  };
}

export default LoadStagingWizardStore;